<template>
  <div>
    <h1>Email Template Revision Copy</h1>
    <p>
      Copy a template revision to another email template. (*** denotes current
      email template)
    </p>
    <div
      v-for="emailTemplate in computedEmailTemplates"
      :key="emailTemplate.id"
      class="email-template"
    >
      <v-btn @click="copyEmailTemplateRevision(emailTemplate)"
        ><v-icon>content_copy</v-icon> Copy</v-btn
      >
      <span class="selected" v-if="emailTemplate.id == $route.params.id"
        >***</span
      >
      <span>{{ emailTemplate.emailTemplateRevision.subject }}</span>
    </div>
  </div>
</template>

<script>
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "EmailTemplateRevisionCopy",
  metaInfo() {
    return {
      title: "Email Template Revision Copy",
      titleTemplate: "%s - Sales - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  computed: {
    computedEmailTemplates() {
      if (!this.emailTemplates) {
        return undefined;
      }
      return this.emailTemplates.filter((et) => et.emailTemplateRevision);
    }
  },
  data() {
    return {
      emailTemplates: null
    };
  },
  methods: {
    async fetchEmailTemplates() {
      const response = await nbmlaw.get(`/cors/admin/sales/emailTemplates`);
      // console.log(response.data);
      this.emailTemplates = response.data;
    },
    async copyEmailTemplateRevision(emailTemplate) {
      const response = await nbmlaw.post(
        `/cors/admin/sales/emailTemplateRevisions/${this.$route.params.revisionid}/copy`,
        {
          emailTemplateId: emailTemplate.id
        }
      );
      this.$router.push({
        name: "emailTemplateRevisionSales",
        params: { id: emailTemplate.id, revisionid: response.data }
      });
    }
  },
  created() {
    this.fetchEmailTemplates();
  }
};
</script>

<style scoped>
.email-template {
  padding: 10px;
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
    0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
  margin-bottom: 10px;
  border: 1px solid black;
  background-color: lightsteelblue;
}
.email-template .selected {
  color: red;
}
</style>